import type { RouteRecordRaw } from 'vue-router';

export const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'initial',
    component: () => import('../views/InitialPage.vue')
  },
  {
    path: '/gps-error',
    name: 'gps-error',
    component: () => import('../views/GpsErrorPage.vue')
  },
  {
    path: '/appointment-error',
    name: 'appointment-error',
    props: route => ({ ...route.query }),
    component: () => import('../views/ErrorScreenPage.vue')
  },
  {
    path: '/warehouse-error',
    name: 'warehouse-error',
    props: route => ({ ...route.query }),
    component: () => import('../views/ErrorScreenPage.vue')
  },
  {
    path: '/rejected-check-in',
    name: 'rejected-check-in',
    component: () => import('../views/RejectedCheckinPage.vue')
  },
  {
    path: '/completed',
    name: 'completed',
    props: route => ({ ...route.query }),
    component: () => import('../views/CheckinCompletePage.vue')
  },
  {
    path: '/verification-error',
    name: 'verification-error',
    props: route => ({ ...route.query }),
    component: () => import('../views/VerificationFailedPage.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/NotFound.vue')
  }
];
